<template>
  <div class="page-container has-action">
    <van-nav-bar fixed title="线下转账" left-arrow @click-left="goableBack()" />
    <div class="recharge_offline">
      <div class="recharge_offline-box">
        <!-- <div class="ro-title">您已超过银行支付渠道限额</div> -->
        <div class="ro-title">请使用线下转账</div>
        <div>
          <div class="offline-account_title">线下转账账户</div>
          <div class="radius-box offline-account_box">
            <div class="account-item">
              <div class="content">
                <div>
                  <span class="title">账户名称：</span>
                  <span class="text">{{ payType.offlineName }}</span>
                </div>
                <div class="ctrl">
                  <button @click="onCopy('EFT-bank-name')" id="EFT-bank-name" :data-clipboard-text="payType.offlineName">
                    点击复制
                  </button>
                </div>
              </div>
            </div>
            <div class="account-item">
              <div class="content">
                <div>
                  <span class="title">银行账户：</span>
                  <span class="number">{{ payType.offlineAccount }}</span>
                  <br />
                  <span class="title">开户行：</span>
                  <span class="text">{{ payType.offlineBank }}</span>
                </div>
                <div class="ctrl">
                  <button @click="onCopy('EFT-bank-id')" id="EFT-bank-id" :data-clipboard-text="payType.offlineAccount">
                    点击复制
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="radius-box step-box">
          <div class="step_title">操作步骤</div>
          <div class="step_content">
            <div class="step">
              1：请复制以上信息，使用网银、手机银行或银行柜台对上述对公账户转账。
            </div>
            <div class="step">
              2：转账完成之后请致电客服热线:40069-40070或在微信公众号后台留言，或将转账截图发给您的微信客服专员
            </div>
            <div class="step">3：稍等片刻，天安金交中心后台便可完成调账。</div>
            <div class="step">
              4：您可登录天安金交中心APP或微信公众号来进行查看或投资
            </div>
          </div>
        </div>
        <p class="tips">
          注:微信客服只会提供我司的对公账号,任何提供其他账号的请勿转账
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store"
import ClipboardJS from "clipboard"
import * as PayApi from "@/api/pay"
import session from "@/utils/session"
import { mapGetters } from "vuex"
import {
  Tag,
  Col,
  NavBar,
  Button,
  Cell,
  CellGroup,
  RadioGroup,
  Radio,
  Toast,
  Dialog,
  Field,
  Checkbox,
  Popup,
  Picker
} from "vant"

export default {
  components: {
    [Tag.name]: Tag,
    [Col.name]: Col,
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    [Picker.name]: Picker
  },

  data() {
    return {
      payType: {
        offlineName: "", // 天安（贵州省）互联网金融资产交易中心股份有限公司
        offlineAccount: "", // 8546 1001 0122 805876
        offlineBank: "" // 恒丰银行股份有限公司东营分行
      },
      payTypeBL: {
        offlineName: "", // 天安（贵州省）互联网金融资产交易中心股份有限公司
        offlineAccount: "", // 8546 1001 0122 805876
        offlineBank: "" // 恒丰银行股份有限公司东营分行
      }
    }
  },

  beforeRouteEnter(to, from, next) {
    if (store.getters.userInfo.isBindCard) {
      next()
    } else {
      session.setJson({ target: "recharge_offline" })
      next({ name: "bindcard", query: { redirect: "recharge_offline" } })
    }
  },

  beforeMount() {
    PayApi.paytype()
      .then((data) => {
        this.payType = data
      })
      .catch((e) => {
        Toast(e.msg || e.message)
      })

    PayApi.paytype({ chanlCode: "BL" })
      .then((data) => {
        this.payTypeBL = data
      })
      .catch((e) => {
        Toast(e.msg || e.message)
      })
  },

  methods: {
    // 线下支付模态框, 点击 `点击复制`
    onCopy(elementId) {
      let clipboard = new ClipboardJS(`#${elementId}`)
      clipboard.on("success", function (e) {
        Toast(`已经复制到您的剪切板`)
        e.clearSelection()
      })

      clipboard.on("error", function (e) {
        Toast(`不支持自动复制，请手动复制`)
      })
    },

    onConfirm() {
      const objQuery = this.$route.query
      if (
        objQuery &&
        objQuery.redirect &&
        objQuery.redirect.includes("/user")
      ) {
        this.$router.push({ path: "/user" })
      } else if (
        objQuery &&
        objQuery.redirect &&
        objQuery.redirect.includes("/buying")
      ) {
        this.$router.push({ path: "/invest" })
      } else {
        this.goableBack()
      }
    }
  },
  computed: {
    ...mapGetters(["channel", "userInfo"])
  }
}
</script>

<style lang="less" scoped>
@import "./idx.less";
::v-deep .tian-amount {
  .van-field__left-icon {
    font-weight: 600;
  }

  .van-field__left-icon,
  .van-field__control {
    font-size: 32px;
    line-height: 36px;
  }
}
.page-container {
  height: 100%;
  background: #ffe0bd;

  .tips {
    margin-top: 30px;
    font-size: 10px;
    height: 10px;
    text-align: center;
    line-height: 10px;
  }
  .step-box {
    margin-top: 20px;
    padding-top: 20px;
    .step_title {
      display: flex;
      justify-content: center;
      color: white;
      width: 100px;
      height: 30px;
      line-height: 30px;
      background-image: url(../../assets/img/recharge/offline-thumb.png);
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100px 30px;
    }

    .step_content {
      margin: 0px 20px;
      background: #ffe0bd;
      .step {
        margin-bottom: 0.5px;
        background-color: white;
        font-size: 16px;
        padding-top: 20px;
        padding-bottom: 20px;
        color: #d79e6f;
      }
    }
  }

  .offline-account_title {
    position: relative;
    display: flex;
    justify-content: center;
    color: white;
    width: 150px;
    height: 50px;
    top: 30px;
    margin: 0px auto;
    line-height: 50px;
    background-image: url(../../assets/img/recharge/offline-title-bg.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 150px 50px;
  }

  .radius-box {
    background-color: white;
    border-radius: 10px;
    margin-left: 0.2rem;
    margin-right: 0.2rem;
  }
  .offline-account_box {
    padding-top: 20px;
  }
}
.recharge_offline-box {
  padding-top: 30px;

  .ro-title,
  .ro-desc {
    text-align: center;
  }

  .ro-title {
    font-family: PingFangSC-Medium;
    font-size: 48/2px;
    letter-spacing: 4/2px;
    color: #ff7903;
    text-shadow: 2px 3px 1px white;
  }

  .ro-desc {
    font-family: PingFangSC-Semibold;
    font-size: 24/2px;
    letter-spacing: 0;
    color: #999999;
    margin-top: 10px;
  }

  .account-item {
    padding: 15px 15px;
    white-space: nowrap;
    position: relative;

    .title {
      font-weight: 600;
    }

    .content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .text {
        white-space: normal;
        padding-right: 20px;
        width: 70%;
      }
      .ctrl {
        margin-left: 10px;
        button {
          border-radius: 5px;
          border: solid 1px #e96b44;
          padding: 5px 8px;
          background-color: white;
          background-image: none;
          color: #e96b44;
        }

        button:active {
          background-color: #e96b44;
          color: #fff;
        }
      }
    }
  }

  .ro-bank-account {
    margin-top: 66/2px;

    .roba-bank-name {
      font-family: PingFangSC-Regular;
      font-size: 10px;
      letter-spacing: 0px;
      color: #999999;
    }
  }
}
</style>
